<template>
  <div
    class="discount-item"
  >
    <span class="bold bl-color font-size-16 mr-2">{{ discount.zmena }}%</span>
    <div>
      {{ discount.label }} - <span v-if="discount.poznamka"> {{ discount.poznamka }}</span>
    </div>
    <div v-if="discount.auto_applied" class="discount-item__automatic">
      Automaticky uplatnené
    </div>
    <div v-else-if="!loading">
      <span
        v-if="!picked"
        class="ml-2 text-cta noselect"
        @click="applySadzbaChange(discount.id, discount.zmena)"
      >
        Uplatniť
      </span>
      <span
        v-else
        class="ml-2 text-cta noselect"
        @click="removeSadzbaChange(discount.id, discount.zmena)"
      >
        Zrušiť
      </span>
    </div>
    <div class="ml-3" v-else>
      <v-progress-circular
        class="loading-spinner extrasmall"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiscountItem",
  props: {
    discount: Object,
    mortgageRateChanges: Array,
    mortgageId: Number,
  },
  computed: {
    picked() {
      return this.mortgageRateChanges.includes(this.discount.id)
    }
  },
  methods: {
    async applySadzbaChange (id, change) {
      this.loading = true;
      const sadzby = [...this.mortgageRateChanges, id];
      this.$store.commit("mortgageDetailState/setAppliedMortgageRateChanges", sadzby);
      const mortgageObject = {
        id: this.mortgageId,
        object: {
          uplatnene_zmeny_sadzieb: sadzby,
        },
      }
      await this.$store.dispatch("mortgageDetailState/patchMortgage", mortgageObject);
      this.$emit("discount-change", change);
      this.loading = false;
    },
    async removeSadzbaChange (id, change) {
      this.loading = true;
      const sadzby = [...this.mortgageRateChanges];
      const index = sadzby.indexOf(id);
      sadzby.splice(index, 1);
      this.$store.commit("mortgageDetailState/setAppliedMortgageRateChanges", sadzby);
      const mortgageObject = {
        id: this.mortgageId,
        object: {
          uplatnene_zmeny_sadzieb: sadzby,
        },
      }
      await this.$store.dispatch("mortgageDetailState/patchMortgage", mortgageObject);
      this.$emit("discount-change", change);
      this.loading = false;
    },
  },
  data: () => ({
    loading: false,
  }),
}
</script>

<style lang="scss" scoped>
.discount-item {
  margin: 0;
  padding: 8px 11px;
  gap: 5px;
  border: 1px solid var(--app-border);
  border-radius: 9px;
  background: var(--app-surface-muted);
  color: var(--app-text);
  font-size: 10px;
}

.discount-item .font-size-16 {
  color: var(--app-primary) !important;
  font-size: 13px !important;
  font-weight: 800;
}

.discount-item .text-cta {
  color: var(--app-primary) !important;
  padding: 5px 8px !important;
  border-radius: 7px;
  background: var(--app-primary-soft);
  font-size: 10px;
  font-weight: 800;
}

.discount-item__automatic {
  margin-left: 8px;
  padding: 5px 8px;
  border-radius: 7px;
  background: var(--app-warning-soft, #fff4d6);
  color: var(--app-warning, #8a5a00);
  font-size: 10px;
  font-weight: 800;
}
</style>
